<template>
  <div class="anomaly-colorbar">
    <div class="ticks">
      <span v-for="t in ticks" :key="t">{{ t }}</span>
    </div>
    <div class="bar"></div>
    <div class="labels">
      <span>{{ t("underperforming") }}</span>
      <span>{{ t("outperforming") }}</span>
    </div>
  </div>
</template>

<script>
/**
 * The fixed Red→Yellow→Green (−3 … +3) z-score deviation colorbar shown on the
 * Anomaly Detection report. Rendered as a CSS gradient so it is crisp and its
 * labels localize (the Python colorbar image is not used).
 */
export default {
  name: "AnomalyColorbar",
  props: {
    i18nPrefix: { type: String, default: "reports.anomalyDetection" },
  },
  data() {
    return {
      ticks: [-3, -2, -1, 0, 1, 2, 3],
    };
  },
  methods: {
    t(key) {
      return this.$t(`${this.i18nPrefix}.${key}`);
    },
  },
};
</script>

<style scoped>
.anomaly-colorbar {
  max-width: 520px;
}
.ticks,
.labels {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  color: #494949;
}
.labels {
  color: #1e1e1e;
  margin-top: 3px;
}
.bar {
  height: 18px;
  border-radius: 3px;
  margin: 2px 0;
  background: linear-gradient(
    to right,
    #a50026,
    #d73027,
    #f46d43,
    #fdae61,
    #fee08b,
    #ffffbf,
    #d9ef8b,
    #a6d96a,
    #66bd63,
    #1a9850,
    #006837
  );
}
</style>
